export default {
  meta: {
    title: '属性管理',
  },
};
